module.exports = __webpack_public_path__ + "images/Open bill_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Open bill_hover.png
// module id = 390
// module chunks = 0 1